  <template>
  <!-- Row -->
  <div class="generic-form row">
    <div :class="`container ${classes}`">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default border-panel card-view">
            <div v-if="!readOnly" class="panel-heading">
              <div class="pull-left">
                <h6 class="panel-title txt-dark">{{title}}</h6>
              </div>
              <div class="clearfix"></div>
            </div>
            <div v-if="errors.length > 0" class="panel-heading error-panel">
              <div class="pull-left">
                <!-- <h6 class="panel-title txt-dark">{{'Felmerülő problémák'}}</h6> -->
                <ul class="error-list">
                  <li v-for="(error,index) in errors" :key="index">{{error}}</li>
                </ul>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="form-wrap">
                  <form v-if="model">
                    <div v-for="(field, index) in fields" :key="index" :class="classesFor(field)">
                      <div v-if="field.type === 'checkboxList'">
                        <label
                          class="control-label mb-10"
                        >{{ $t('app.verification_questions.specializations') }}</label>
                        <div v-for="(item,index) in field.list" :key="index">
                            <base-checkbox
                              :id="item.value.toString()"
                              :labelValue="$t(`app.specializations.${item.text}`)"
                              :value="selectedSpecs.includes(item.text)"
                              @valueChanged="selectSpec(item.text)"
                            />
                          </div>
                      </div>
                      <div v-if="field.type === 'text' && !field.withHint">
                        <form-input
                          v-model="model[field.name]"
                          :type="'text'"
                          :inputDisabled="disabledFields.includes(field.name)"
                          labelClassNames="control-label mb-10 text-left"
                          :classNames="`form-control rounded`"
                          :inputClasses="field.inputClasses"
                          :placeholder="$t(`app.${modelName}.attributes_placeholders.${field.name}`)"
                          :labelValue="$t(`app.${modelName}.attributes.${field.name}`)"
                        />
                      </div>
                      <div v-if="field.type === 'text' && field.withHint">
                        <form-input
                          :withHint="field.withHint"
                          v-model="model[field.name]"
                          :type="'text'"
                          :inputDisabled="disabledFields.includes(field.name)"
                          labelClassNames="control-label mb-10 text-left"
                          :classNames="`form-control rounded`"
                          :inputClasses="field.inputClasses"
                          :placeholder="$t(`app.${modelName}.attributes_placeholders.${field.name}`)"
                          :labelValue="$t(`app.${modelName}.attributes.${field.name}`)"
                        />
                      </div>
                      <div v-if="field.type === 'number'">
                        <form-input
                          v-model="model[field.name]"
                          :type="'number'"
                          labelClassNames="control-label mb-10 text-left"
                          classNames="form-control rounded"
                          :placeholder="$t(`app.${modelName}.attributes_placeholders.${field.name}`)"
                          :labelValue="$t(`app.${modelName}.attributes.${field.name}`)"
                        />
                      </div>
                      <div v-if="field.type === 'date'">
                        <form-input
                          v-model="model[field.name]"
                          :value="model[field.name]"
                          :type="'date'"
                          :inputDisabled="disabledFields.includes(field.name)"
                          labelClassNames="control-label mb-10 text-left"
                          :classNames="disabledFields.includes(field.name) ? 'form-control rounded disabled-date-picker' : 'form-control rounded'"
                          :placeholder="$t(`app.${modelName}.attributes_placeholders.${field.name}`)"
                          :labelValue="$t(`app.${modelName}.attributes.${field.name}`)"
                          @inputChange="dateChanged($event, field.name)"
                        />
                      </div>
                      <div v-if="field.type === 'text-area'">
                        <text-area
                          v-model="model[field.name]"
                          :type="'text'"
                          :needValidation="field.needValidation"
                          labelClassNames="control-label mb-10 text-left"
                          classNames="form-control rounded"
                          :placeholder="$t(`app.${modelName}.attributes_placeholders.${field.name}`)"
                          :labelValue="$t(`app.${modelName}.attributes.${field.name}`)"
                        />
                      </div>
                      <div v-else-if="field.type === 'dropdown' && field.action != undefined && field.name === 'area_color' && !readOnly" >
                        <color-picker
                          :color-options="colors"
                          :label="$t('app.locations.color_placeholder')"
                          empty-option="None"
                          :defaultValue="model[field.default_key]"
                          @input="sendAction($event, field.action)"
                          v-model="model[field.name]">
                        </color-picker>
                      </div>
                      <div v-else-if="field.type === 'dropdown' && field.action != undefined && !readOnly" >
                        <base-dropdown
                          :forLocation="field.name === 'site_id'"
                          :id="field.name"
                          :list="field.dropdownList"
                          v-model="model[field.name]"
                          :defaultValue="model[field.name]"
                          labelClassNames="control-label mb-10 text-left"
                          :labelValue="$t(`app.${modelName}.attributes.${field.name}`)"
                          @input="sendAction($event, field.action,field.name)"
                          :ref="`${field.name}_${field.action}`"
                        />
                      </div>
                      <div v-else-if="field.type === 'dropdown' && !readOnly">
                        <base-dropdown
                          :id="field.name"
                          :list="field.dropdownList"
                          :inputDisabled="disabledFields.includes(field.name)"
                          v-model="model[field.name]"
                          :defaultValue="model[field.name]"
                          labelClassNames="control-label mb-10 text-left"
                          :labelValue="$t(`app.${modelName}.attributes.${field.name}`)"
                          :ref="`${field.name}`"
                        />
                      </div>
                      <div v-else-if="field.type === 'file'">
                        <span>{{field.title?field.title : $t('app.verification_questions.assetsTitle')}}</span>
                        <base-file-uploader
                          :multiple="field.multiple"
                          labelClassNames="control-label mb-10 text-left"
                          classNames="upload-drop-zone"
                          :placeholder="$t(`app.${modelName}.attributes_placeholders.${field.name}`)"
                          :labelValue="$t(`app.${modelName}.attributes.${field.name}`)"
                          @input="assignFile($event, field.name,field.multiple)"
                        />
                        <component
                          v-bind:is="'asset-card-row'"
                          :assets="assets"
                          :assetClassName="field.forLocation && field.forLocation === true ? 'col-sm-12' : 'col-sm-6'"
                          @deleteAsset="deleteAsset"
                          :visible="rowVisible"
                        />
                        <component
                          v-if="asset"
                          v-bind:is="'asset-card'"
                          :asset="asset"
                          :imagePath="asset.url"
                          @deleteAsset="deleteAsset"
                          :visible="visible"
                        />
                      </div>
                      <div v-else-if="field.type === 'tag'">
                        <label
                          class="control-label mb-10 text-left"
                        >{{ $t(`app.${modelName}.attributes.${field.name}`) }}</label>
                        <multiselect v-model="locations"
                          :options="filteredTags(field.list)"
                          :multiple="false"
                          :selectLabel="$t('app.multiselect.select')"
                          :selectedLabel="$t('app.multiselect.selected')"
                          :deselectLabel="$t('app.multiselect.remove')"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          :placeholder="$t(`app.${modelName}.attributes_placeholders.${field.name}`)"
                          label="name"
                          track-by="id"
                          :preselect-first="false"
                          @input="tagsChanged">
                          <span slot="noOptions">{{$t('app.generals.empty_list')}}</span>
                          <template #noResult>
                            {{$t('app.generals.empty_list')}}
                          </template>
                          </multiselect>
                      </div>
                      <div v-else-if="field.type === 'geometry' && (field.url !== undefined && field.url !== null)">
                        <label
                          class="control-label mb-10 text-left"
                        >{{ $t(`app.${modelName}.attributes.${field.name}`) }}</label>
                        <canvas-area
                          :locations="model"
                          :area="field.area"
                          :selectedColor="color"
                          @addCoordinate="addCoordinate"
                          :imageUrl="field.url"
                          :readOnly="readOnly"
                        />
                      </div>
                      <div v-else-if="field.type === 'map'">
                        <label
                          class="control-label mb-10 text-left"
                        >{{ $t(`app.${modelName}.attributes.${field.name}`) }}</label>
                        <site-canvas
                          :locations="model.locations"
                          :imageUrl="model.map_url"
                        />
                      </div>
                      <div v-else-if="field.type === 'specializations-selector'">
                        <label
                          class="control-label mb-10 text-left"
                        >{{ $t(`app.verification_questions.specializations`) }}</label>
                        <div v-for="(spec,index) in specializations" :key="index">
                            <base-checkbox
                              :id="spec.value.toString()"
                              :labelValue="$t(`app.specializations.${spec.text}`)"
                              :value="model.specializations.map((x) => x.name).includes(spec.text)"
                              @valueChanged="selectSpec(spec.text)"
                            />
                          </div>
                      </div>
                    </div>
                    <div class="form-group modal-buttons">
                      <div :class="'col-md-12'">
                        <div class="text-right">
                          <base-button
                            v-if="!readOnly"
                            :isLoading="isLoading"
                            :title="submitTitle"
                            :classNames="`btn btn-orange rounded`"
                            @clicked="submit"
                          />
                          <base-button
                            :title="readOnly? $t('app.modal.cancel') : cancelTitle"
                            :classNames="`btn btn-default btn-outline rounded`"
                            @clicked="cancel"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Row -->
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import BaseButton from '@/components/shared/buttons/FormButton';
import BaseDropdown from '@/components/shared/inputs/BaseDropDown';
import BaseCheckbox from '../../shared/inputs/BaseCheckbox';
import ColorDropdown from '@/components/shared/inputs/ColorDropdown';
import ColorPicker from '@/components/shared/inputs/ColorPicker';
import FormInput from '@/components/shared/inputs/FormInput';
import BaseTextArea from '@/components/shared/inputs/BaseTextArea';
import AssetCardRow from '@/components/shared/inputs/AssetCardRow';
import AssetCard from '@/components/shared/inputs/AssetCard';
import BaseFileUploader from '@/components/shared/inputs/BaseFileUploader';
import Canvas from '@/components/shared/inputs/Canvas';
import SiteCanvas from '@/components/modules/partners/SiteLocations';

export default {
  name: 'GenericForm',
  components: {
    'base-button': BaseButton,
    'base-dropdown': BaseDropdown,
    'color-dropdown': ColorDropdown,
    'color-picker': ColorPicker,
    'base-file-uploader': BaseFileUploader,
    'form-input': FormInput,
    'vue-tags-input': VueTagsInput,
    'asset-card-row': AssetCardRow,
    'asset-card': AssetCard,
    'text-area': BaseTextArea,
    'canvas-area': Canvas,
    'site-canvas': SiteCanvas,
    BaseCheckbox,
  },
  props: {
    model: {
      type: Object,
      required: false,
    },
    modelName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    cancelTitle: {
      type: String,
      required: true,
    },
    submitTitle: {
      type: String,
      required: true,
    },
    selection: {
      type: String,
      required: false,
    },
    hasMultipleColumn: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disabledFields: {
      type: Array,
      default: () => [],
    },
    specializations: {
      type: Array,
      default: () => [],
    },
    classes: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selectedSpecs: [],
      errors: [],
      isLoading: false,
      currentTagValue: '',
      asset_ids: [],
      asset_id: null,
      assets: [],
      asset: {},
      mapUrl: undefined,
      assetsCount: 0,
      visible: false,
      rowVisible: false,
      locations: [],
      participants: [],
      coordinates: [],
      colors: [
        {
          hex: '#ff000080',
          name: '#ff000080',
        },
        {
          hex: '#00ff0080',
          name: '#00ff0080',
        },
        {
          hex: '#0000ff80',
          name: '#0000ff80',
        },
        {
          hex: '#ffd70080',
          name: '#ffd70080',
        },
        {
          hex: '#80008080',
          name: '#80008080',
        },
        {
          hex: '#ffffff80',
          name: '#ffffff80',
        },
        {
          hex: '#00000080',
          name: '#00000080',
        },
        {
          hex: '#00ffff80',
          name: '#00ffff80',
        },
        {
          hex: '#ff00ff80',
          name: '#ff00ff80',
        },
        {
          hex: '#06553580',
          name: '#06553580',
        },
        {
          hex: '#ff737380',
          name: '#ff737380',
        },
        {
          hex: '#ffff0080',
          name: '#ffff0080',
        },
        {
          hex: '#ffc3a080',
          name: '#ffc3a080',
        },
        {
          hex: '#20b2aa80',
          name: '#20b2aa80',
        },
        {
          hex: '#f0808080',
          name: '#f0808080',
        },
        {
          hex: '#f6546a80',
          name: '#f6546a80',
        },
        {
          hex: '#66cdaa80',
          name: '#66cdaa80',
        },
        {
          hex: '#66006680',
          name: '#66006680',
        },
        {
          hex: '#8b000080',
          name: '#8b000080',
        },
        {
          hex: '#79404480',
          name: '#79404480',
        },
      ],
    };
  },
  created() {
    if (this.model && this.model.specializations) {
      this.selectedSpecs = this.model.specializations.map(x => x.name);
    }
    this.$eventBus.onStopLoading(this, () => {
      this.isLoading = false;
    });
    this.$eventBus.onGetError(this, (payload) => {
      this.errors = payload;
    });
    if (this.model.assets) {
      this.rowVisible = true;
      this.assets = this.model.assets.map(asset => ({
        id: asset.id,
        file_name: asset.file_name,
        file_size: this.$options.filters.prettyBytes(asset.file_size),
        url: asset.url,
        content_type: asset.content_type,
      }));
      this.assets.forEach((asset) => {
        this.asset_ids = this.asset_ids.concat(asset.id);
        this.assetsCount += 1;
      });
    } else if (this.model.asset) {
      this.visible = true;
      this.assetsCount = 1;
      this.asset_id = this.model.asset.id;
      this.asset = {
        id: this.model.asset.id,
        file_name: this.model.asset.file_name,
        file_size: this.$options.filters.prettyBytes(
          this.model.asset.file_size,
        ),
        content_type: this.model.asset.content_type,
        url: this.model.asset.url,
      };
    } else if (this.model.map) {
      this.visible = true;
      this.assetsCount = 1;
      this.asset_id = this.model.map.id;
      this.asset = {
        id: this.model.map.id,
        file_name: this.model.map.file_name,
        file_size: this.$options.filters.prettyBytes(this.model.map.file_size),
        content_type: this.model.map.content_type,
        url: this.model.map.url,
      };
    }
    if (this.model.locations) {
      this.locations = this.model.locations.map(location => ({ id: location.id, name: location.name }));
    }

    if (this.model.participants) {
      this.participants = this.model.participants.map(participant => ({ id: participant.id, text: participant.name }));
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
        selectSpec(value) {
      if (!this.selectedSpecs.includes(value)) {
        this.selectedSpecs.push(value);
      } else {
        this.selectedSpecs = this.selectedSpecs.filter(x => x !== value);
      }
      this.$emit('selectSpec', this.selectedSpecs);
    },
    tagData(dataName) {
      switch (dataName) {
        case 'locations': {
          return this.locations;
        }
        case 'participants': {
          return this.participants;
        }
      }
    },
    classesFor(field) {
      if (field.classes) {
        return `form-group ${field.classes}`;
      }
      return 'form-group col-md-12';
    },
    submit() {
      this.isLoading = true;
      if (this.model.assets) {
        this.model.asset_ids = this.asset_ids;
      } else if (this.model.asset) {
        this.model.asset_id = this.asset_id;
      } else if (this.model.map) {
        this.model.asset_id = this.asset_id;
      }

      if (this.coordinates.length > 0) {
        this.model.coordinates = this.coordinates;
      }

      if (this.selectedSpecs.length > 0) {
        this.model.specializations = this.selectedSpecs;
      }
      this.$emit('submit', this.model);
    },
    cancel() {
      this.$eventBus.hideModal();
      this.$emit('modalCanceled');
    },
    assignFile(files, fieldName, multiple) {
      if (multiple) {
        this.model[fieldName] = [];
        this.rowVisible = true;
        for (let index = 0; index < files.length; index++) {
          this.model[fieldName] = this.model[fieldName].concat(files[index]);
          this.addFileToAssets(files[index]);
        }
      } else {
        this.model[fieldName] = {};
        this.asset = {
          id: Math.random() * Math.floor(1000),
          file_name: files.name,
          file_size: this.$options.filters.prettyBytes(files.size),
          content_type: files.type,
        };
        this.model[fieldName] = files;
        this.visible = true;
      }
    },
    addFileToAssets(file) {
      const asset = {
        id: Math.random() * Math.floor(1000),
        file_name: file.name,
        file_size: this.$options.filters.prettyBytes(file.size),
        content_type: file.type,
        visible: true,
      };
      this.assets = this.assets.concat(asset);
    },
    sendAction(value, action, fieldName = null) {
      const simpleDropdownRef = this.$refs['verification_question_id']
      if (action === 'selectCategory') {
        const dropdownRef = this.$refs['sub_criteria_category_id_selectSubCategory']
        if (dropdownRef && dropdownRef[0]) {
          dropdownRef[0].selected = null
          this.model['sub_criteria_category_id'] = null
          if (simpleDropdownRef && simpleDropdownRef[0]) {
            simpleDropdownRef[0].selected = null
            this.model['verification_question_id'] = null
          }
        }
      }
      if (action === 'selectSubCategory') {
        const dropdownRef = this.$refs['criteria_category_id_selectCategory']
        if (dropdownRef && dropdownRef[0]) {
          if(dropdownRef[0].selected != undefined) {
            dropdownRef[0].selected = null
            this.model['criteria_category_id'] = null
            if (simpleDropdownRef && simpleDropdownRef[0]) {
              simpleDropdownRef[0].selected = null
              this.model['verification_question_id'] = null
            }
          }
        }
      }
      this.$emit('sendAction', { value, action });
    },
    filteredList(list, tag) {
      if (list) {
        return list.filter(i => i.text.toLowerCase().indexOf(tag.toLowerCase()) !== -1);
      }
    },
    filteredTags(list) {
      let array = [];
      list.forEach((element) => {
        const object = { name: element.text, id: element.id };
        array = array.concat(object);
      });
      return array;
    },
    deleteAsset(id) {
      let deletableIndex;
      if (this.model.assets || this.assets && this.assets.length > 0) {
        for (let index = 0; index < this.assets.length; index++) {
          if (this.assets[index].id === id) {
            deletableIndex = index;
          }
        }
        if (this.model.files) {
          this.model.files.splice(deletableIndex - this.assetsCount, 1);
        }
        this.assets.splice(deletableIndex, 1);
        this.asset_ids.splice(deletableIndex, 1);
      } else if (this.model.file) {
        console.log(document.getElementById('base-file-input').value)
        document.getElementById('base-file-input').value = null;
        this.visible = false;
        this.asset = undefined;
        this.asset_id = null;
      } else if (this.model.asset) {
        this.visible = false;
        this.asset = undefined;
        this.asset_id = null;
      } else if (this.model.map) {
        this.visible = false;
        this.asset = undefined;
        this.asset_id = null;
      }
    },
    tagsChanged(content) {
      const locArray = [];
      if (this.model.locations) {
        locArray.push(content);
        this.model.locations = locArray;
      }

      if (this.model.participants) {
        this.model.participants = content;
      }
    },
    addCoordinate(coordinates) {
      this.coordinates = coordinates;
    },
    dateChanged(event, fieldName) {
      this.model[fieldName] = event;
    },
  },
  watch: {
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.generic-form {

  .detailed-form {
    .form-group {
      margin-bottom: 5px;
    }

    .asset-col {
      margin-bottom: 15px;
    }
  }
  .land-register-input {
    width: 50%;
    padding-right: 15px;
  }

  .error-panel {
    margin-top: 5px !important;
  }

  .error-list {
    color: #ff2626;
    list-style-type: disc;
    padding-left: 15px;
  }
  /deep/ .multiselect__tag {
    background: var(--main-color);
  }

  /deep/ .multiselect__tags {
    margin-bottom: 20px;
  }

  /deep/ .multiselect__tag-icon:hover {
    background: var(--main-color);
  }

  /deep/ .multiselect__tag-icon:after {
    color: #000;
  }

  /deep/ .multiselect__option--highlight {
    background: #ff61289f;
  }

  .modal-buttons {
    clear: left;
    padding-right: 15px;
  }
  .rounded {
    border-radius: 4px;
  }

  .input-title {
    color: #808495;
    font-size: 13px;
  }

  .site-map {
    width: 100%;
  }

  .col-padding {
    padding-right: 7em;
  }
  .vue-tags-input {
    max-width: 100%;
  }

  .without-float {
    clear: left;
  }

  & /deep/ .ti-input {
    border: none !important;
    input[type="text"] {
      font-family: 'Roboto', sans-serif !important;
    }
  }
  & /deep/ .ti-tag {
    background-color: var(--main-color) !important;
    .ti-tag-center {
      font-family: 'Roboto', sans-serif !important;
    }
  }
  & /deep/ .ti-deletion-mark {
    background-color: #ee234f !important;
  }
  & /deep/ .ti-tag:before {
    display: none !important;
  }
/deep/ .multiselect__option--highlight:after {
  background: none;
}

/deep/ .multiselect__option--selected.multiselect__option--highlight:after {
  background: none;
}

/deep/ .multiselect__option--selected.multiselect__option--highlight {
    background: #ff282873 !important;
}
}

</style>



// WEBPACK FOOTER //
// src/components/shared/forms/GenericForm.vue